<template>
    <v-row>
        <v-col>
            <report-list />
        </v-col>
    </v-row>
</template>

<script>
    import ReportList from '@/components/CustomReport/ReportList.vue';

    export default {
        name: 'CustomReportHomePage',

        components: {
            ReportList,
        },

        data: () => ({
            selectedReportId: undefined,
            showReport: false,
        }),

        methods: {
            onReportClick(reportId) {
                this.selectedReportId = reportId;
                this.showReport = true;
            },
        },
    };
</script>
